import { render, staticRenderFns } from "./adjustment-price-details.vue?vue&type=template&id=522f73a8&scoped=true"
import script from "./adjustment-price-details.vue?vue&type=script&lang=js"
export * from "./adjustment-price-details.vue?vue&type=script&lang=js"
import style0 from "./adjustment-price-details.vue?vue&type=style&index=0&id=522f73a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f73a8",
  null
  
)

export default component.exports